import { getToken } from "./authHeaderService";
import { apiInstance } from "./axiosService";
import { convertObjToQueryParams } from "./commonHelper";

export const getAllQuiz = async (payload = {}) => {
    let res = await apiInstance.get("quiz" + convertObjToQueryParams(payload), { headers: getToken() });
    let data = { data: { records: res?.data, totalRecords: res?.data?.length }, ok: res?.ok }
    return data;
};

export const addQuiz = (payload) => {
    return apiInstance.post("quiz/addQuiz", payload, { headers: getToken() });
};


export const deleteQuizById = async (payload) => {
    const res = await apiInstance.delete(`quiz/deleteQuizById/${payload?.id}`, { headers: getToken() });
    return res;
};

export const getQuiz = async (payload = {}) => {
    let res = await apiInstance.get(`quiz/${payload?.id}`, { headers: getToken() });
    let data = { data: { records: res?.data?.questions, totalRecords: res?.data?.questions?.length }, ok: res?.ok }
    return data;
};

export const addQuizQuestion = (payload) => {
    return apiInstance.post("quiz/addQuizQuestion", payload, { headers: getToken() });
};

export const deleteQuizQuestionById = (payload) => {
    return apiInstance.post("quiz/deleteQuizQuestionById", payload, { headers: getToken() });
};

export const getAllQuestions = async (payload = {}) => {
    let res = await apiInstance.get("question" + convertObjToQueryParams(payload), { headers: getToken() });
    let data = { data: { records: res?.data, totalRecords: res?.data?.length }, ok: res?.ok }
    return data;
};

export const addQuestion = (payload) => {
    return apiInstance.post("question/addQuestion", payload, { headers: getToken() });
};

export const deleteQuestionById = (payload) => {
    return apiInstance.delete(`question/deleteQuestionById/${payload?.id}`, { headers: getToken() });
};